import {Sprite, Texture} from 'pixi.js';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';

export type FullScreenSpriteOptions = {
    name?: string;
    screenParameters?: ScreenParameters;
};

export class FullScreenSprite extends Sprite {
    private screenParameters?: ScreenParameters;

    constructor(
        texture: Texture,
        public readonly options: FullScreenSpriteOptions = {}
    ) {
        super(texture);

        const {name = 'FullScreenSprite', screenParameters} = options;

        this.name = name;

        if (screenParameters) {
            this.resize(screenParameters);
        }

        if (!texture.baseTexture.valid) {
            texture.baseTexture.once('loaded', () => {
                if (this.screenParameters) {
                    this.resize(this.screenParameters);
                }
            });
        }
    }

    public resize(screenParameters: ScreenParameters): this {
        const currentWidth = this.texture.width;
        const currentHeight = this.texture.height;
        const props = screenParameters.calcScreenFillProps(currentWidth, currentHeight);

        this.screenParameters = screenParameters;
        this.scale.set(props.scale);
        this.position.set(props.x, props.y);

        return this;
    }
}
